const PRESSURE_WINDOW_MS = 30000;
const LONG_TASK_MIN_MS = 120;
const LONG_TASK_TOTAL_THRESHOLD_MS = 600;

let observerStarted = false;
let pressureUntil = 0;
let longTaskDurations: Array<{ t: number; d: number }> = [];

const markPressure = (now: number) => {
  pressureUntil = Math.max(pressureUntil, now + PRESSURE_WINDOW_MS);
};

const pruneLongTasks = (now: number) => {
  const cutoff = now - PRESSURE_WINDOW_MS;
  longTaskDurations = longTaskDurations.filter((item) => item.t >= cutoff);
};

export const startMainThreadPressureObserver = (): void => {
  if (observerStarted || typeof window === 'undefined' || typeof PerformanceObserver === 'undefined') {
    return;
  }

  observerStarted = true;

  try {
    const observer = new PerformanceObserver((list) => {
      const now = Date.now();
      const entries = list.getEntries();

      for (const entry of entries) {
        if (entry.duration >= LONG_TASK_MIN_MS) {
          longTaskDurations.push({ t: now, d: entry.duration });
        }
      }

      pruneLongTasks(now);
      const totalDuration = longTaskDurations.reduce((sum, item) => sum + item.d, 0);
      if (totalDuration >= LONG_TASK_TOTAL_THRESHOLD_MS) {
        markPressure(now);
      }
    });

    observer.observe({ type: 'longtask', buffered: true } as PerformanceObserverInit);
  } catch {
    // Long task observer unsupported on this browser.
  }
};

export const isMainThreadUnderPressure = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const now = Date.now();
  pruneLongTasks(now);
  return pressureUntil > now;
};
